import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MushroomCurry() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Mushroom Curry</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A creamy, spiced Indian curry with tender mushrooms and rich flavors.</p>
          <span className="season-badge season-monsoon">🌧️ Best in Monsoon</span>
          <ImageWithFallback src="/mushroom-curry.jpg" alt="Mushroom Curry" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>250g mushrooms, cleaned and sliced</li>
              <li>1 large onion, finely chopped</li>
              <li>2 tomatoes, pureed</li>
              <li>2 green chilies, slit</li>
              <li>1 tsp ginger-garlic paste</li>
              <li>1/2 tsp turmeric powder</li>
              <li>1 tsp cumin seeds</li>
              <li>1 tsp coriander powder</li>
              <li>1/2 tsp garam masala</li>
              <li>1/2 tsp red chili powder</li>
              <li>1/2 cup coconut milk or cream</li>
              <li>2 tbsp oil</li>
              <li>Salt to taste</li>
              <li>Fresh cilantro for garnish</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Heat oil in a pan. Add cumin seeds and let them splutter. Add onions and sauté until golden.</li>
              <li>Add ginger-garlic paste and green chilies. Sauté for 1 minute.</li>
              <li>Add pureed tomatoes, turmeric, coriander powder, red chili powder, and salt. Cook until oil separates.</li>
              <li>Add mushrooms and cook for 5-6 minutes until tender.</li>
              <li>Stir in coconut milk/cream and garam masala. Simmer for 3-4 minutes. Garnish with cilantro and serve hot with rice or naan.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Wipe mushrooms clean with a damp cloth instead of soaking — they absorb water and turn rubbery.</li>
              <li>Cook the tomato-onion base until the oil visibly separates; that's the sign the raw taste is gone.</li>
              <li>Don't overcook the mushrooms once added — 5-6 minutes keeps them tender, not chewy.</li>
              <li>Swap coconut milk for cream for a richer, more North Indian-style gravy.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Mushrooms are low in calories but offer B vitamins, potassium, and some vitamin D.</li>
              <li>Tomatoes contribute lycopene and vitamin C to the spiced gravy.</li>
              <li>A great plant-based, protein-light main that's still hearty and filling.</li>
              <li>Turmeric and ginger-garlic paste add natural anti-inflammatory compounds.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default MushroomCurry;
